var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 13H14.2222C14.6518 13 15 12.6518 15 12.2222V5.26667V1.77778C15 1.34822 14.6518 1 14.2222 1H8.77778H1.77778C1.34822 1 1 1.34822 1 1.77778V12.2222C1 12.6518 1.34822 13 1.77778 13H3","stroke":"#1A1D31","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"8","y1":"7","x2":"8","y2":"15","stroke":"#1A1D31","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M11.1995 12.3337L7.9999 15L4.80029 12.3337","stroke":"#1A1D31","strokeWidth":"2","strokeLinejoin":"round","key":2})]);
}

Download.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Download;

Download.default = Download;
